import { Button } from "@/src/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTrigger } from "@/src/components/ui/dialog";
import { Separator } from "@/src/components/ui/separator";
import { useToast } from "@/src/components/ui/use-toast";
import { useRemoveBookingPaymentMutation } from "@/src/lib/bookingRemovePaymentMutation";
import React, { useState } from "react";

interface RemoveBookingPaymentProps {
  paymentId: string;
  bookingId: string;
}

const RemoveBookingPayment: React.FC<RemoveBookingPaymentProps> = ({ paymentId, bookingId }) => {
  const [open, setOpen] = useState(false);
  const { toast } = useToast();
  const removePaymentMutation = useRemoveBookingPaymentMutation(paymentId, bookingId);

  const removePayment = () => {
    const toastId = toast({
      description: "Removing payment...",
      variant: "default",
      duration: Infinity,
    }).id;

    removePaymentMutation.mutate(
      { toastId },
      {
        onSuccess: () => {
          setOpen(false);
        },
      },
    );
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <p className="text-sm text-red-600 font-medium cursor-pointer ml-auto  pl-2 pr-2 pt-4 pb-4">Remove</p>
      </DialogTrigger>
      <DialogContent
        className="max-w-xl"
        style={{
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {" "}
        <DialogHeader>
          <h2 className="text-3xl">Remove payment</h2>
        </DialogHeader>
        <Separator />
        <p className=" text-slate-700">
          Are you sure you want to remove this payment? <strong>This action cannot be undone</strong>.
        </p>
        <div className="flex justify-end">
          <Button variant="destructive" type="submit" onClick={removePayment} className="ml-auto">
            Remove
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RemoveBookingPayment;
